import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ConstraintsPage } from '@/features/siteplan/constraints-page';

const searchSchema = z.object({
  constraint: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/plan/constraints')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const { constraint } = Route.useSearch();
  return <ConstraintsPage projectId={projectId} constraintId={constraint} />;
}
